<template>
  <div id="supprimer-compte" class="gip-max-width">
    <h1>Supprimer mon compte</h1>
    <p>Pour supprimer votre compte, veuillez nous envoyer un mail ou nous appeler.</p>
  </div>
</template>

<script>
export default {
  name: "SupprimerCompte",
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
#supprimer-compte {
  padding-top: 4em;
  background: var(--gip-white-color);
  padding-left: 2em;
  padding-right: 2em;
  padding-bottom: 2em;
}

h1 {
  margin-bottom: 1em;
}

p {
  line-height: 1.6;
}
</style>
